export function getActiveWorkspace(draft) {
    return draft.workspaces[draft.workspace.current || 'default'];
}
